@if (finalUrl) {
@if (finalUrl.fullRedirect) {
<a [ngClass]="className"
   [attr.tabindex]="hrefTabIndex"
   [href]="finalUrl.href"
   [attr.target]="finalUrl.target"
   [attr.aria-label]="hrefAriaLabel">
    <ng-container *ngTemplateOutlet="contentTmpl" />
</a>
} @else {
@if(plain) {
<ng-container *ngTemplateOutlet="contentTmpl" />
}@else {
<a [ngClass]="className"
   [attr.tabindex]="hrefTabIndex"
   [href]="finalUrl.href"
   [attr.target]="finalUrl.target"
   [attr.aria-label]="hrefAriaLabel">
    <ng-container *ngTemplateOutlet="contentTmpl" />
</a>
}
}
} @else {
@if (finalAction && !plain) {
<button [ngClass]="className"
        [attr.tabindex]="hrefTabIndex"
        [attr.aria-label]="hrefAriaLabel">
    <ng-container *ngTemplateOutlet="contentTmpl" />
</button>
} @else {
<ng-container *ngTemplateOutlet="contentTmpl" />
}
}

<ng-template #contentTmpl>
    <ng-content />
</ng-template>